var $9020b37a983f18c7$exports = {};
$9020b37a983f18c7$exports = {
    "breadcrumbs": `Categorias`
};


export {$9020b37a983f18c7$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
